import React, { PureComponent } from 'react';
import { elementContentType } from '../../../../../../../../types';

export default class SpacerElement extends PureComponent {
    state = {
        containerBackgroundColor: 'lightgrey',
        height: 10,
    };

    // To handle undo redo gracefully both on mount and later updates
    static getDerivedStateFromProps(nextProps, prevState) {
        const { content } = nextProps;
        const { containerBackgroundColor, height } = content;
        const newState = { ...prevState, height, containerBackgroundColor };

        if (JSON.stringify(newState) !== JSON.stringify(prevState)) {
            return { ...newState };
        }

        return { ...prevState };
    }

    render() {
        const { height, containerBackgroundColor } = this.state;
        return (
            <table
                style={{ width: '100%', verticalAlign: 'top' }}
                cellSpacing="0"
                cellPadding="0"
                width="100%"
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex="0"
                role="presentation"
            >
                <tbody>
                    <tr>
                        <td
                            style={{
                                fontSize: 0,
                                wordBreak: 'break-word',
                                backgroundColor: containerBackgroundColor,
                            }}
                        >
                            <div style={{ height }} />
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

SpacerElement.propTypes = {
    content: elementContentType.isRequired,
};
